import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'

import BodyText from 'LuxKit/Typography/BodyText'
import Pane from 'components/Common/Pane/Pane'
import Group from 'components/utils/Group'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'

const Container = styled(Pane)`
  padding: ${rem(16)};
`

interface Props {
  content: string
}

function PropertyReviewAiSummary({
  content,
}: Props) {
  const intl = useIntl()
  const aiGeneratedLabel = intl.formatMessage({
    id: 'DGkc7HSskh',
    defaultMessage: 'AI-generated based on customer reviews',
    description: 'Label indicating the review summary was generated by AI from customer reviews',
  })

  return (
    <Container background="neutral-seven">
      <Group direction="vertical" gap={12}>
        <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="end">
          <BodyText variant="large" weight="bold" colour="neutral-two">Summary</BodyText>
          <CSSBreakpoint min="tablet">
            <BodyText variant="medium" colour="neutral-three" align="end">{aiGeneratedLabel}</BodyText>
          </CSSBreakpoint>
        </Group>
        <BodyText variant="large" colour="neutral-two">{content}</BodyText>
        <CSSBreakpoint max="mobile">
          <BodyText variant="medium" colour="neutral-three">{aiGeneratedLabel}</BodyText>
        </CSSBreakpoint>
      </Group>
    </Container>
  )
}

export default React.memo(PropertyReviewAiSummary)
